(function() {
  window.settingsService = {
    get() {
      return axios.get('/api/settings/get.php');
    },
    getByKey(data) {
      return axios.get(`/api/settings/get.php?key=${data.key}`);
    },
    save(data) {
      return axios.post('/api/settings/save.php', data);
    }
  }
})();